<template>
  <printBase ref="LinkQR015" :title='title' :page='page' :width='1024'>
    <div v-for="(pageList, pageIndex) in printInfoList" :key="pageIndex" :slot="page==1? 'content' : `content${pageIndex+1}`" class="printLinkQR">
      <div class="printTitle">重点药品养护记录</div>
      <div>
        <div>重点养护的药品有：1、首营品种；2、近效期药品；3、冷藏药品；4、特殊管理的药品；5、有效期较短；</div>
        <div>6、质量不稳定（易霉变、易潮解和曾经发生过变质）；7、近期出现过质量问题；8、药监部门重点监控的品种</div>
      </div>
      <table style="width: 100%" class='printContent' border='1' cellspacing="0">
        <tr>
          <th style="width: 5%;">养护日期</th>
          <th style="width: 9%;">品名</th>
          <th style="width: 8%;">规格</th>
          <th style="width: 9%;">批准文号</th>
          <th style="width: 5%;">剂型</th>
          <th style="width: 9%;">生产企业</th>
          <th style="width: 9%;">生产批号</th>
          <th style="width: 5%;">有效期至</th>
          <th style="width: 4%;">数量</th>
          <th style="width: 9%;">质量状况</th>
          <th style="width: 9%;">包装情况</th>
          <th style="width: 6%;">养护人</th>
          <th style="width: 5%;">养护方法</th>
          <th style="width: 9%;">结论</th>
        </tr>
        <tbody>
          <tr v-for="(item, printIndex) in pageList" :key="printIndex">
            <td><span>{{ item.curingRecordModifiedTime }}</span></td>
            <td><span>{{ item.curingRecordApprovedDrugNames }}</span></td>
            <td><span>{{ item.curingRecordSpecifications }}</span></td>
            <td><span>{{ item.inventoryInfoApprovalNumber }}</span></td>
            <td><span>{{ item.curingRecordDosageForm }}</span></td>
            <td><span>{{ item.inventoryInfoManufacturer }}</span></td>
            <td><span>{{ item.curingRecordGoodsBatchNumber }}</span></td>
            <td><span>{{ item.inventoryInfoGoodsExpiryDate }}</span></td>
            <td><span>{{ item.curingRecordCuringCount }}</span></td>
            <td><span>{{ item.curingRecordDoubtfulCount > 0 ? item.curingRecordCuringResultStr : '合格' }}</span></td>
            <td><span>{{ item.curingRecordDoubtfulCount > 0 ? item.curingRecordCuringResultStr : '合格' }}</span></td>
            <td><span>{{ item.curingRecordModifiedUserName }}</span></td>
            <td><span></span></td>
            <td><span>{{ item.curingRecordCuringResultStr }}</span></td>
          </tr>
        </tbody>

      </table>
    </div>
  </printBase>
</template>
<script>
import _ from 'lodash';
import printBase from './printBase';
import utils from '../../libs/utils';

export default {
  data() {
    return {
      title: 'Link-QR-015',
      printInfoList: [],
      page: 1,
      pageSize: 25,
    };
  },
  components: {
    printBase,
  },
  methods: {
    handlePrint(value) {
      console.log(value);
      const infoList = [];
      // debugger;
      value.forEach((item) => {
        const result = {};
        utils.exchangeTable(item, result);
        result.curingRecordModifiedTime = utils.formatDate(result.curingRecordModifiedTime);
        result.inventoryInfoGoodsExpiryDate = utils.formatDate(result.inventoryInfoGoodsExpiryDate);
        result.curingRecordCuringResultStr = `${utils.fixNumber(result.curingRecordCuringCount - result.curingRecordDoubtfulCount, 2) || 0}合格, ${result.curingRecordDoubtfulCount || 0}存疑`;
        infoList.push(result);
      });
      this.printInfoList = _.chunk(infoList, this.pageSize);
      this.page = this.printInfoList.length;
      this.$nextTick(() => {
        console.log(this.printInfoList);
        this.$refs.LinkQR015.handlePrint();
      });
    },
  },
  mounted() {
  },
};
</script>
<style lang="less" scoped>
.printContent th {
  white-space: nowrap;
}
.printContent td,th{
    text-align: center;
    position: relative;
    border-color: #000;
    font-weight: normal;
    word-break: break-all;
    padding: 2px;
    font-size: 12px;
    color: #000;
    *{
      display: inline-block;
      /*max-height: 16px;*/
      height: 32px;
      max-height: 32px;
      overflow:hidden
    }

  }
</style>
